import { ErrorType } from './error.types';

export class UnauthorizedException extends Error {
    statusCode: number;
    code: string;
    type = ErrorType.Unauthorized;
    executor: any;

    constructor({ message = 'Unauthorized', code, executor }: { message?: string; code?: string; executor?: any }) {
        super(message);
        this.name = 'UnauthorizedException';
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore - Fix TS FS-3199
        this.code = code;
        this.executor = executor;
        this.statusCode = 401;
    }
}
